function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(2.664 0 0 2.664 .033463 .063931)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m24 11.247a12.012 12.012 0 1 0-11.983 12.753h6.983a5.005 5.005 0 0 0 5-5zm-2 7.753a3 3 0 0 1-3 3h-6.983a10.041 10.041 0 0 1-7.476-3.343 9.917 9.917 0 0 1-2.476-7.814 10.043 10.043 0 0 1 8.656-8.761 10.564 10.564 0 0 1 1.3-0.082 9.921 9.921 0 0 1 6.379 2.3 10.041 10.041 0 0 1 3.6 7.042z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8 9h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 11h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 15h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2z"
}));
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.41718759.svg";
export { ForwardRef as ReactComponent };